<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-width="1rem">
          <el-form-item label="真实手机号" prop="realPhone">
            <el-input
              v-model="form.realPhone"
              clearable
              autocomplete="off"
              maxlength="30"
              placeholder="请输入真实手机号"
            />
          </el-form-item>
          <el-form-item label="真实价格" prop="realPrice">
            <el-input
              v-model="form.realPrice"
              clearable
              type="number"
              autocomplete="off"
              maxlength="50"
              placeholder="请输入真实价格"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>
          <el-form-item label="车牌号" prop="plateNumber">
            <el-input
              v-model="form.plateNumber"
              clearable
              autocomplete="off"
              maxlength="50"
              placeholder="请输入车牌号"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, editInfo, setReal } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "信息填写",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        orderId: "",
        realPrice: "",
        realPhone: "",
        plateNumber: "",
      },
      rules: {
        // realPrice: [{ required: true, message: "设备编号不能为空" }],
        // realPhone: [{ required: true, message: "设备位置信息不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    init(row) {
      if (!!row) {
        this.form.realPrice = row.realPrice;
        this.form.realPhone = row.realPhone;
        this.form.plateNumber = row.plateNumber;
        this.form.orderId = row.orderId;
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            orderId: this.form.orderId,
            realPrice: this.form.realPrice,
            realPhone: this.form.realPhone,
            plateNumber: this.form.plateNumber,
          };
          setReal(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("设置成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
